export default function IntentDescription() {
    return (
        <div className="row mt-4">
            <p className="mb-2">
                使用此服务发送的数据是端到端加密的，并在浏览器之间实时传输。任何文件数据，无论是明文还是加密的，都不会接触到服务器。
            </p>
        </div>
    )
}